import {
  useQuery,
  useMutation,
  useQueryClient,
  keepPreviousData,
} from "@tanstack/react-query";
import { shipmentService } from "../services/svc_shipments";
import { queryKeys } from "../lib/queryKeys";
import { ListRequest } from "../types/common/commonTypes";

export const useTSQShipmentList = (
  params: ListRequest,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: queryKeys.shipment.list(params),
    queryFn: () => shipmentService.list(params),
    placeholderData: keepPreviousData,
    enabled: enabled,
  });
};

export const useTSQShipment = (id: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: queryKeys.shipment.detail(id),
    queryFn: () => shipmentService.getById(id),
    enabled: !!id && enabled,
  });
};

export const useTSMCreateShipment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: shipmentService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.shipment.lists() });
    },
    onError: (error) => {
      console.error("Failed to create Shipment:", error);
    },
  });
};

export const useTSMUpdateShipment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      shipmentService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.shipment.lists() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.address.details(),
      });
    },
    onError: (error) => {
      console.error("Failed to update Shipment:", error);
    },
  });
};
